import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GlobalRealtimeMoveUpdatesSubscriptionVariables = Types.Exact<{
  cursor: Array<Types.InputMaybe<Types.Moves_Stream_Cursor_Input>> | Types.InputMaybe<Types.Moves_Stream_Cursor_Input>;
  startTime: Types.Scalars['timestamptz']['input'];
  endTime: Types.Scalars['timestamptz']['input'];
}>;


export type GlobalRealtimeMoveUpdatesSubscription = { __typename?: 'subscription_root', moves_stream: Array<{ __typename?: 'moves', id: number, status?: string | null, driver_status?: string | null, driver_id?: number | null, plan_id?: number | null, lane_id?: number | null, ready_by?: string | null, pickup_time?: string | null, delivery_time?: string | null, updatedat?: string | null, pickup_started?: string | null, pickup_arrived?: string | null, pickup_successful?: string | null, delivery_started?: string | null, delivery_arrived?: string | null, delivery_successful?: string | null, cancel_status?: string | null, active: number, settled: boolean, hangtags: Array<{ __typename?: 'hangtags', id: number, rear_code?: string | null, status: string }> }> };


export const GlobalRealtimeMoveUpdatesDocument = gql`
    subscription globalRealtimeMoveUpdates($cursor: [moves_stream_cursor_input]!, $startTime: timestamptz!, $endTime: timestamptz!) {
  moves_stream(
    cursor: $cursor
    batch_size: 50
    where: {active: {_eq: 1}, status: {_neq: "delivery successful"}, cancel_status: {_is_null: true}, _or: [{pickup_time: {_gte: $startTime, _lte: $endTime}}, {ready_by: {_gte: $startTime, _lte: $endTime}}]}
  ) {
    id
    status
    driver_status
    driver_id
    plan_id
    lane_id
    ready_by
    pickup_time
    delivery_time
    updatedat
    pickup_started
    pickup_arrived
    pickup_successful
    delivery_started
    delivery_arrived
    delivery_successful
    cancel_status
    active
    settled
    hangtags(order_by: {updated_at: desc}, limit: 1) {
      id
      rear_code
      status
    }
  }
}
    `;

/**
 * __useGlobalRealtimeMoveUpdatesSubscription__
 *
 * To run a query within a React component, call `useGlobalRealtimeMoveUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGlobalRealtimeMoveUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalRealtimeMoveUpdatesSubscription({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useGlobalRealtimeMoveUpdatesSubscription(baseOptions: Apollo.SubscriptionHookOptions<GlobalRealtimeMoveUpdatesSubscription, GlobalRealtimeMoveUpdatesSubscriptionVariables> & ({ variables: GlobalRealtimeMoveUpdatesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GlobalRealtimeMoveUpdatesSubscription, GlobalRealtimeMoveUpdatesSubscriptionVariables>(GlobalRealtimeMoveUpdatesDocument, options);
      }
export type GlobalRealtimeMoveUpdatesSubscriptionHookResult = ReturnType<typeof useGlobalRealtimeMoveUpdatesSubscription>;
export type GlobalRealtimeMoveUpdatesSubscriptionResult = Apollo.SubscriptionResult<GlobalRealtimeMoveUpdatesSubscription>;